var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 158,
    viewBox: "0 0 111 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6025 105.926C86.656 122.057 123.288 139.675 126.59 133.562C129.892 127.449 114.37 110.101 93.1257 89.341C70.7503 67.458 55.0255 61.2597 47.2164 63.6195C34.5732 67.4825 38.5602 89.8369 62.6025 105.926Z",
    fill: "#D4C962"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7521 61.7686C116.444 90.9348 135.391 139.773 127.544 143.212C119.96 146.522 106.718 124.509 78.5521 96.5728C51.0629 69.3912 19.1683 33.409 22.5661 23.9434C29.0827 5.96336 66.9923 21.263 95.7521 61.7686Z",
    fill: "#D4C962"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.031 141.211L127.719 140.047C127.626 139.7 127.537 139.368 127.448 139.035C127.266 138.356 126.938 137.686 126.682 137.116C122.799 128.161 114.588 121.049 106.271 116.311C93.1266 108.723 78.5735 103.964 63.9397 100.176C56.7188 98.3089 49.418 96.6411 42.1532 95.0527C36.0954 93.7054 29.4448 91.0316 23.2461 91.8162C17.0474 92.6009 18.9789 99.0344 22.0564 101.938C49.9929 128.242 93.5828 116.295 120.031 143.354C120.791 144.146 123.617 144.725 124.649 145.087C127.238 146.057 128.642 143.379 128.031 141.211Z",
    fill: "#F6DF8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsRight);
export default __webpack_public_path__ + "static/media/stars-right.ba68657892e76f0c4cba27b42efe1a06.svg";
export { ForwardRef as ReactComponent };